import { StudyDemoTutorReplay } from '@/pages/try/studyExperience/StudyDemoTutorReplay';
import { STUDY_DEMO_CASES } from '@/pages/try/studyExperience/exampleData';
import { isLocalStudyExperience } from '@/pages/try/studyExperience/mode';
import { useWorkingViewport } from './workingOverlay';
import { useEffect, useState, type ComponentProps } from 'react';
import { StudyPdfTutorPanel } from './StudyPdfTutorPanel';
import { StudyPdfDocumentTutor } from './StudyPdfDocumentTutor';
export function StudyPdfWorkspaceTutor(
  props: ComponentProps<typeof StudyPdfTutorPanel> & { onPage: (page: number) => void },
) {
  const viewport = useWorkingViewport(true);
  const [scope, setScope] = useState<'document' | 'page'>('document');
  const [pageVisited, setPageVisited] = useState(false);
  const [documentBusy, setDocumentBusy] = useState(false);
  const [pageBusy, setPageBusy] = useState(false);
  const onBusyChange = props.onBusyChange;
  useEffect(() => {
    onBusyChange(documentBusy || pageBusy);
  }, [onBusyChange, documentBusy, pageBusy]);
  if (isLocalStudyExperience()) {
    const index =
      props.fileName === 'alex-worked-solutions.pdf'
        ? props.pageNumber - 1
        : (props.pageNumber - 1) * 4;
    const initialKey = STUDY_DEMO_CASES[index]?.key ?? 'linear';
    return <StudyDemoTutorReplay key={initialKey} initialKey={initialKey} />;
  }
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className={viewport.height <= 500 ? 'hidden' : 'shrink-0 border-b border-hairline p-2'}>
        <label className="flex items-center gap-2 text-xs font-bold text-slate2">
          Context
          <select
            aria-label="Tutor reads"
            value={scope}
            disabled={documentBusy || pageBusy}
            onChange={(event) => {
              const next = event.target.value as 'document' | 'page';
              setScope(next);
              if (next === 'page') setPageVisited(true);
            }}
            className="min-h-11 min-w-0 flex-1 rounded-xl border border-hairline bg-canvas-pure px-3 text-xs font-bold text-ink"
          >
            <option value="document">Whole PDF</option>
            <option value="page">This page image</option>
          </select>
        </label>
      </div>
      <div
        id="pdf-tutor-source"
        role="region"
        aria-label={scope === 'document' ? 'Whole PDF conversation' : 'Current page conversation'}
        className="flex min-h-0 flex-1 flex-col"
      >
        <div
          hidden={scope !== 'document'}
          className={scope === 'document' ? 'flex min-h-0 flex-1 flex-col' : 'hidden'}
        >
          <StudyPdfDocumentTutor
            documentId={props.documentId}
            fileName={props.fileName}
            active={props.active && scope === 'document'}
            onBusyChange={setDocumentBusy}
            onPage={props.onPage}
          />
        </div>
        <div
          hidden={scope !== 'page'}
          className={scope === 'page' ? 'flex min-h-0 flex-1 flex-col' : 'hidden'}
        >
          {pageVisited && (
            <StudyPdfTutorPanel
              {...props}
              active={props.active && scope === 'page'}
              onBusyChange={setPageBusy}
            />
          )}
        </div>
      </div>
    </div>
  );
}
